import { CustomIcon } from 'modules/components/layer00';
import { SaveProjectForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';



export type SaveProjectModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveProjectModalProps) => {
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      handleClose={() => {
        props.handleClose();
      }}
      title={props.id === '' ? 'Create Project' : 'Edit Project'}
      subTitle='Enter Information about your project to get started'
      headerIcon={<CustomIcon.large.FC icon='CREATOR' />}
      fullScreen
    >
      <SaveProjectForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );
};
